import { settings } from '../../../settings/settings-util'
import Renderers from './renderers/renderer'

export default class SingleLinkRenderer {
    constructor(passedSettings, getHistoryWatcher, commandActionHandler=null) {
        this._settings = passedSettings || settings;
        this._renderers = new Renderers(this._settings, {}, getHistoryWatcher, commandActionHandler);
    }

    static getDefaultSettings()
    {
        return settings;
    }

    initialize(store) {
        this._renderers.initialize(store);
    }

    getMapper(options={}) {
        return this._renderers.getNew(options);
    }

    getReducer() {
        return (state) => { return state; };
    }

    getRenderer(){
        return this._renderers.getRender();
    }

    renderLink(link, response=null){
        return this._renderers.linksMapper(link, response);
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/single-link-renderer/src/single-link-renderer.js